import AdvancedBoxScoreTable from "./AdvancedBoxScoreTable";

export default AdvancedBoxScoreTable;
